import {
  Stack,
  Typography,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Modal,
  Switch,
} from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Logo from "../../asset/Logo.jpg";
import { useState, useRef } from "react";
import AddMinor from "./addMinor";
import Agreement from "./Agreement";
// import SignatureCanvas from "react-signature-canvas";
import SignaturePad from "./SignaturePad";
import { postRequest } from "../../util/request/request";
import LoadingModal from "./loadingModal";
import { useTranslation } from "react-i18next";

const WaiverForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    birthDateDay: "",
    birthDateMonth: "",
    birthDateYear: "",
    email: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
  });

  const [minorValue, setMinorValueFromChild] = useState([]);
  //   const [signatureData, setSignatureData] = useState("");

  const [showForm, setShowForm] = useState(true);
  const [showFinishPage, setShowFinishPage] = useState({ status: "waiting" });
  const [clickSubmit, setClickSubmit] = useState(false);
  const { t, i18n } = useTranslation();
  const [checked, setChecked] = useState(false);

  const handleMinorValueChange = (value) => {
    value.minorId = minorValue.length + 1;
    setMinorValueFromChild((prev) => [...prev, value]);
  };

  const submitFinalForm = async (value) => {
    let data1 = { ...formData, signature: value };
    let data2 = { ...data1, minors: minorValue, timeStamp: new Date() };
    console.log(data2);
    setClickSubmit(true);
    const result = await postRequest({ subLink: "waiver", data: data2 });
    if (result.status === "success") {
      setShowFinishPage(result);
    }
  };

  const deleteMinor = (e) => {
    console.log(e.target.value);
    setMinorValueFromChild((prevItems) =>
      prevItems.filter((item) => item.minorId != e.target.value)
    );
  };

  const handleChange = (e) => {
    console.log(e.target);
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  console.log(formData);
  console.log(minorValue);

  const handleSubmitFirst = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    const validateFormData = Object.values(formData).every(
      (value) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) &&
        !(
          typeof value === "object" &&
          value !== null &&
          Object.keys(value).length === 0
        )
    );
    console.log(validateFormData);
    if (validateFormData && minorValue.length > 0) {
      setShowForm(false);
    }
  };

  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const years = Array.from(
    { length: 82 },
    (_, i) => new Date().getFullYear() - 17 - i
  );

  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const handleLanguageChange = (event) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      i18n.changeLanguage("es");
    } else {
      i18n.changeLanguage("en");
    }
  };
  return (
    <Stack
      direction="row"
      justifyContent="center"
      sx={{ height: "100%", width: "100%", minWidth: "200px" }}
    >
      {/* <button onClick={() => i18n.changeLanguage("en")}>English</button> */}
      {/* <button onClick={() => i18n.changeLanguage("es")}>Español</button> */}
      {showFinishPage.status === "waiting" && (
        <Stack
          direction="column"
          justifyItems="center"
          alignItems="center"
          spacing={2}
          sx={{
            width: { xs: "370px", sm: "500px", md: "800px", lg: "1000px" },
          }}
        >
          <Stack width={"100%"} alignItems="end">
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    label="Required"
                    checked={checked}
                    onChange={handleLanguageChange}
                    slotProps={{ input: { "aria-label": "controlled" } }}
                    sx={{ align: "end" }}
                  />
                }
                label="Spanish"
              />
            </FormGroup>
          </Stack>

          <img src={Logo} alt={"logo"} style={{ height: "20%" }} />

          <Typography component="h2">{t("welcome")}</Typography>
          <Typography component="h2">{t("over_18")}</Typography>
          {showForm && (
            <Stack
              direction="column"
              //   alignItems="end"
              spacing={2}
              paddingX={2}
              component="form"
              useFlexGap
              sx={{ flexWrap: "wrap" }}
              onSubmit={handleSubmitFirst}
              maxWidth="600px"
            >
              <Stack width={"100%"}>
                <Box
                  sx={{
                    paddingBottom: "5px",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <label>{t("parent_info")} </label>
                </Box>
                <TextField
                  label={t("parent_first_name")}
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  variant="standard"
                  sx={{ minWidth: "120px" }}
                />
                <TextField
                  label={t("parent_last_name")}
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  variant="standard"
                  sx={{ minWidth: "120px" }}
                />

                <Stack direction="row" alignItems="end">
                  <Box sx={{ paddingBottom: "5px" }}>
                    <label>{t("DOB_parent")}: </label>
                  </Box>

                  <Stack
                    direction="row"
                    component="form"
                    sx={{ width: "300px", marginLeft: "10px" }}
                  >
                    <FormControl variant="standard" sx={{ minWidth: 80 }}>
                      <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={formData.birthDateMonth}
                        onChange={handleChange}
                        label="MM"
                        required
                        sx={{ width: "60px" }}
                        name="birthDateMonth"
                      >
                        {[
                          ["01", "Jan"],
                          ["02", "Feb"],
                          ["03", "Mar"],
                          ["04", "Apr"],
                          ["05", "May"],
                          ["06", "Jun"],
                          ["07", "Jul"],
                          ["08", "Aug"],
                          ["09", "Sept"],
                          ["10", "Oct"],
                          ["11", "Nov"],
                          ["12", "Dec"],
                        ].map((m) => (
                          <MenuItem key={m[0]} value={m[0]}>
                            {m[1]}
                          </MenuItem>
                        ))}
                        {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                      </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ minWidth: 80 }}>
                      <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={formData.birthDateDay}
                        onChange={handleChange}
                        label="DD"
                        name="birthDateDay"
                        required
                        sx={{ width: "60px" }}
                      >
                        {days.map((day) => (
                          <MenuItem
                            key={day}
                            value={day < 10 ? "0" + day : day}
                          >
                            {day}
                          </MenuItem>
                        ))}

                        {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                      </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ minWidth: 120 }}>
                      <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={formData.birthDateYear}
                        onChange={handleChange}
                        required
                        label="YYYY"
                        name="birthDateYear"
                        sx={{ width: "70px" }}
                      >
                        {years.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}

                        {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                      </Select>
                    </FormControl>
                  </Stack>
                </Stack>
                <TextField
                  label={t("parent_email")}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  type="email"
                  required
                  variant="standard"
                  sx={{ minWidth: "120px" }}
                />
                <TextField
                  label={t("parent_phone")}
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  type="tel"
                  required
                  variant="standard"
                  sx={{ minWidth: "120px" }}
                />
                <TextField
                  label={t("address")}
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                  variant="standard"
                  sx={{ minWidth: "120px" }}
                />
                <TextField
                  label={t("city")}
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  variant="standard"
                  sx={{ minWidth: "120px" }}
                />
                <Stack direction="row" alignItems="end" spacing={2}>
                  <FormControl variant="standard" sx={{ minWidth: 100 }}>
                    <InputLabel id="demo-simple-select-standard-label">
                      {t("state")}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={formData.state}
                      onChange={handleChange}
                      label={t("state")}
                      name="state"
                      required
                      sx={{ width: "100px" }}
                    >
                      {states.map((state) => (
                        <MenuItem key={state} value={state}>
                          {state}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label={t("zip")}
                    name="zipcode"
                    value={formData.zipcode}
                    onChange={handleChange}
                    required
                    variant="standard"
                    sx={{ width: "100px" }}
                  />
                </Stack>
                <Box
                  sx={{ paddingY: "10px", width: "100%", textAlign: "center" }}
                >
                  {t("child_info")}
                </Box>
                <Stack direction="column" spacing={2}>
                  {minorValue.length > 0 ? (
                    minorValue.map((e) => (
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          border: "2px lightBLUE solid",
                          borderRadius: "10px",
                          padding: "10px",
                        }}
                      >
                        <Stack>
                          <Box>
                            {e.firstName} {e.lastName}
                          </Box>
                          <Box>
                            {e.birthDateMonth}-{e.birthDateDay}-
                            {e.birthDateYear}
                          </Box>
                          <Box></Box>
                        </Stack>
                        {/* {e.firstName} ({e.birthDateDay}-{e.birthDateMonth}-
                        {e.birthDateYear}) {e.relation} */}
                        <Button
                          value={e.minorId}
                          variant="outlined"
                          size="small"
                          //   sx={{ margin: 2 }}
                          onClick={deleteMinor}
                        >
                          {t("remove")}
                        </Button>
                      </Stack>
                    ))
                  ) : (
                    <></>
                  )}
                </Stack>
                <Box
                  sx={{
                    paddingBottom: "5px",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <AddMinor onValueChange={handleMinorValueChange} />
                  <Box
                    sx={{
                      paddingBottom: "5px",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{ width: "150px", margin: 5 }}
                    >
                      {t("next")}
                    </Button>
                  </Box>
                </Box>
              </Stack>
            </Stack>
          )}
          {!showForm && (
            // {true && (
            <>
              <Button
                variant="outlined"
                sx={{ margin: 2 }}
                onClick={(e) => setShowForm(true)}
              >
                Back
              </Button>
              <Box padding={2}>
                <Agreement />
              </Box>
              <SignaturePad submitForm={submitFinalForm} />
            </>
          )}
        </Stack>
      )}
      {showFinishPage.status === "success" && (
        <Stack
          direction="column"
          justifyItems="center"
          alignItems="center"
          spacing={2}
          sx={
            {
              // width: " 300px",
              // height: "400px",
              //   backgroundColor: "#d1d1d1",
            }
          }
        >
          <img src={Logo} alt={"logo"} style={{ height: "20%" }} />
          {/* <Typography component="h2">Waiver Completed</Typography> */}
        </Stack>
      )}

      {clickSubmit && <LoadingModal submitedData={showFinishPage} />}
      {/* {true && true && <LoadingModal  />} */}
    </Stack>
  );
};

export default WaiverForm;
